import React from 'react';
import { Button, Grid, GridColumn, Heading, Icon, Modal, ModalCloser, ModalContent, ModalFooter, Text } from '@teliaee/design-system';
import useStores from '../stores/UseStores';

interface PasskeyDeleteConfirmationModalProps {
  onConfirm: () => void;
}

const PasskeyDeleteConfirmationModal = (props: PasskeyDeleteConfirmationModalProps): React.JSX.Element => {
  const { onConfirm } = props;
  const {
    translateStore: { translate },
  } = useStores();
  return (
    <Modal size="6-col">
      <ModalContent>
        <Grid horizontalGutter="none">
          <GridColumn width={['xs-12']}>
            <Grid align={['center-xs']} gutter="none">
              <GridColumn width={['min-xs']}>
                <Icon size="lg" modifiers="#alert" className="c-error-text" verticalAlign="middle" />
              </GridColumn>
            </Grid>
          </GridColumn>
          <GridColumn width={['xs-12']}>
            <Heading level={1} className="h3 text-center">
              {translate('account.passkey.modal.title')}
            </Heading>
          </GridColumn>
          <GridColumn width={['xs-12']}>
            <Text element="p">{translate('account.passkey.modal.description')}</Text>
          </GridColumn>
        </Grid>
      </ModalContent>
      <ModalFooter>
        <Grid align={['between-xs', 'middle-xs']} gutter="small">
          <GridColumn width={['min-xs']}>
            <ModalCloser>
              <Button iconLeft="#close" text={translate('account.passkey.modal.back')} link />
            </ModalCloser>
          </GridColumn>
          <GridColumn width={['min-xs']}>
            <ModalCloser>
              <Button iconLeft="#trashcan-empty" type="withdrawal" text={translate('account.passkey.modal.confirm')} onClick={onConfirm} size="small" />
            </ModalCloser>
          </GridColumn>
        </Grid>
      </ModalFooter>
    </Modal>
  );
};

export default PasskeyDeleteConfirmationModal;
